import {
  Deletable,
  Identifiable,
  Factory,
  Role,
  Device,
  Phone,
  Email,
  CustomerRole,
  LocationRole,
  PresenceRole,
  SiteRole,
  Scope,
  GlobalRole,
  LanguageCode,
} from '../'
import { rememberPayload } from '../../_utils/fcdc-v2'

export class User implements Deletable, Identifiable {
  id: string
  test: boolean
  phone?: Phone
  email?: Email
  visitedSites: string[]
  firstName?: string
  preferredName?: string
  middleNames?: string[]
  lastName?: string
  preferredLanguage?: LanguageCode
  roles: Role[]
  devices: Device[]
  deleteAfter?: Date
  deleted?: boolean
  created: Date
  modified: Date

  constructor(json: any) {
    this.id = json.id
    this.test = Boolean(json.test)
    this.phone = json.phone ? Phone.getFactory().make(json.phone) : undefined
    this.email = json.email ? Email.getFactory().make(json.email) : undefined
    this.visitedSites = json.visitedSites
    this.firstName = json.firstName
    this.preferredName = json.preferredName
    this.middleNames = json.middleNames
    this.lastName = json.lastName
    this.preferredLanguage = json.preferredLanguage
    this.roles = json.roles
      ? json.roles.map((roleJson: any) => Role.getFactory().make(roleJson))
      : []
    this.devices = json.devices
      ? json.devices.map((deviceJson: any) => new Device(deviceJson))
      : []
    this.deleteAfter = json.deleteAfter ? new Date(json.deleteAfter) : undefined
    this.deleted = json.deleted ? Boolean(json.deleted) : false
    this.created = new Date(json.created)
    this.modified = new Date(json.modified)
    rememberPayload(this, json)
  }

  public static getFactory(): Factory<User> {
    return new (class implements Factory<User> {
      make(json: any): User {
        return new User(json)
      }

      getTableName(): string {
        return 'users'
      }
    })()
  }

  static getUrl(userId?: string): string {
    return '/users' + (userId ? '/' + userId : '')
  }

  getName(includeMiddlename: boolean = false): string {
    let fullName = this.firstName || ''

    if (includeMiddlename && this.middleNames && this.middleNames.length > 0) {
      fullName += ' ' + this.middleNames.join(' ')
    }

    if (this.lastName) {
      if (fullName.length > 0) fullName += ' '
      fullName += this.lastName
    }

    return fullName
  }

  hasRole(scopes: Scope[], id?: string, ignoreGlobal: boolean = false): boolean {
    return this.roles.some(role => {
      let isIdMatch = false

      if (role instanceof LocationRole) {
        isIdMatch = !id || role.id === id
      } else if (role instanceof SiteRole) {
        isIdMatch = !id || role.id === id
      } else if (role instanceof PresenceRole) {
        isIdMatch = !id || role.id === id
      } else if (role instanceof CustomerRole) {
        isIdMatch = !id || role.id === id
      } else if (role instanceof GlobalRole && !ignoreGlobal) {
        isIdMatch = true
      }

      const hasMatchingScope = scopes.some(scope => role.scopes & scope)

      return isIdMatch && hasMatchingScope
    })
  }
}
